module.exports = __webpack_public_path__ + "img/headshot_lazy.0b6b176b.jpg";